// @flow

/* -----------------Types--------------- */
import type {
  ChromeHeaderState,
} from './types';

const initialState: ChromeHeaderState = {
  searchFocused: false,
};

export {
  // eslint-disable-next-line import/prefer-default-export
  initialState,
};
